/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MineLocationResponse
 */
export interface MineLocationResponse {
    /**
     * 
     * @type {number}
     * @memberof MineLocationResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof MineLocationResponse
     */
    siteId?: number;
    /**
     * 
     * @type {string}
     * @memberof MineLocationResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MineLocationResponse
     */
    externalId?: string;
}

/**
 * Check if a given object implements the MineLocationResponse interface.
 */
export function instanceOfMineLocationResponse(value: object): value is MineLocationResponse {
    return true;
}

export function MineLocationResponseFromJSON(json: any): MineLocationResponse {
    return MineLocationResponseFromJSONTyped(json, false);
}

export function MineLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MineLocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
    };
}

export function MineLocationResponseToJSON(json: any): MineLocationResponse {
    return MineLocationResponseToJSONTyped(json, false);
}

export function MineLocationResponseToJSONTyped(value?: MineLocationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'siteId': value['siteId'],
        'name': value['name'],
        'externalId': value['externalId'],
    };
}

